var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pb-3",
      style: !_vm.isMobilePort ? "margin-right: 115px;" : "",
    },
    [
      _c(
        _vm.isLink ? "a" : "div",
        {
          tag: "component",
          attrs: { href: _vm.isLink ? _vm.link : null, target: "_blank" },
          on: {
            click: function ($event) {
              _vm.isLink ? _vm.registerClick() : null
            },
          },
        },
        [
          _c(
            "h4",
            {
              staticClass: "d-inline",
              class: _vm.isLink ? "primary--text" : "",
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-inline content-section-tags" },
        [
          _vm.insightsCount
            ? _c(
                "v-tooltip",
                {
                  attrs: { color: "black", "open-delay": "750", bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-chip",
                              _vm._g(
                                {
                                  staticClass: "pa-1 font-weight-bold",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    tabindex: "0",
                                    "x-small": "",
                                    color: "accent2Light",
                                    label: "",
                                  },
                                  on: {
                                    keydown: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.openInsights.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    click: _vm.openInsights,
                                  },
                                },
                                on
                              ),
                              [
                                _c("span", [
                                  _vm._v(
                                    "INSIGHTS (" +
                                      _vm._s(_vm.insightsCount) +
                                      ")"
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1027871733
                  ),
                },
                [
                  _vm._v(" "),
                  _c("span", { staticClass: "tooltip-content" }, [
                    _vm._v("Jump to Insights"),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }